import { render, staticRenderFns } from "./_coupon_data_table.vue?vue&type=template&id=6f48670c"
import script from "./_coupon_data_table.vue?vue&type=script&lang=js"
export * from "./_coupon_data_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports